import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useState,
} from 'react';

// INVALIDATING cache

import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';

import client from '../config/contentful';
import theme from '../config/theme';

import Loader from './Loader';
import StoreContext from '../contexts/Store';
import ToggleContactContext from '../contexts/ToggleContact';

const App = () => {
  const [Router, setRouter] = useState(null);
  const [isContactOpened, setIsContactOpened] = useState(false);
  const [minTimeReached, setMinTimeReached] = useState(false);
  const [store, setStore] = useState(null);

  useEffect(() => {
    const sixBefore = new Date();
    sixBefore.setMonth(sixBefore.getMonth() - 5);
    sixBefore.setDate(1);

    const promises = [
      client.getEntries({
        content_type: 'article',
        'fields.date[gte]': sixBefore.toISOString().substring(0, 10),
        order: '-fields.date',
      }),
      client.getEntries({
        content_type: 'brand',
        order: 'fields.order',
      }),
      client.getEntries({
        content_type: 'case',
        order: 'fields.number',
      }),
      client.getEntries({
        content_type: 'filter',
        limit: 15,
        order: 'fields.order',
      }),
      client.getEntries({
        content_type: 'influencer',
        order: 'fields.order',
      }),
      client.getEntries({
        content_type: 'partner',
        order: 'fields.order',
      }),
      client.getAsset('1Ib9iDxrzvTR9NsX1JIyQQ'), // Video3D — audio
      client.getAsset('6lDzx62D2wiFfdfHBVEwUk'), // Video3D — video DT
      client.getAsset('5gOOfjOp9HBr5ZOVPUusSR'), // Video3D — video MB
      import(
        /* webpackChunkName: 'router' */
        './Router'
      ),
    ];
    Promise.all(promises).then(([
      { items: articles },
      { items: brands },
      { items: cases },
      { items: filters },
      { items: influencers },
      { items: partners },
      video3dAudio,
      video3dVideoDT,
      video3dVideoMB,
      { default: Component },
    ]) => {
      setStore({
        articles,
        brands,
        cases,
        filters,
        influencers,
        partners,
        video3dAudio,
        video3dVideoDT,
        video3dVideoMB,
      });
      setRouter(() => Component);
    });
  }, []);

  useEffect(() => {
    setTimeout(() => setMinTimeReached(true), 2000);
  }, []);

  useLayoutEffect(() => {
    const onResize = () => {
      const windowHeight = window.innerHeight;
      const app = document.getElementById('app');
      app.style.setProperty('height', `${windowHeight}px`);
      app.style.setProperty('--vh', `${windowHeight * 0.01}px`);
    };

    onResize();

    window.addEventListener('resize', onResize);
  }, []);

  const toggleContact = useCallback(() => {
    setIsContactOpened((val) => !val);
  }, []);

  if (!(store && Router && minTimeReached)) { return <Loader />; }

  return (
    <StoreContext.Provider value={store}>
      <ToggleContactContext.Provider value={toggleContact}>
        <ThemeProvider theme={theme}>
          <BrowserRouter>
            <Router
              isContactOpened={isContactOpened}
              toggleContact={toggleContact}
            />
          </BrowserRouter>
        </ThemeProvider>
      </ToggleContactContext.Provider>
    </StoreContext.Provider>
  );
};

export default App;
